import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import "./index.css";

console.log("🚀 Admin Panel - Initializing React...");
console.log("Root element:", document.getElementById("root"));

try {
  console.log("📦 Creating React root and mounting app with ErrorBoundary");
  createRoot(document.getElementById("root")).render(
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>
  );
  console.log("✅ React App mounted successfully with error boundary");
} catch (error) {
  console.error("❌ Error mounting React app:", error);
  document.body.innerHTML = `<pre style="color: red; padding: 20px; font-family: monospace; background: black; margin: 0;">
Error mounting app:
${error.message}
${error.stack}
  </pre>`;
}
